module.exports = __webpack_public_path__ + "img/logo.a1086600.png";